import { environment } from 'src/environments/environment.staging';
import * as i0 from "@angular/core";
var MyTeamsAccessGuard = /** @class */ (function () {
    function MyTeamsAccessGuard() {
    }
    MyTeamsAccessGuard.prototype.canActivate = function (route, state) {
        var isNewVersion = localStorage.getItem('isMyTeamsNewVersion');
        if (isNewVersion === "true") {
            var currentPath = state.url.startsWith("/") ? state.url : "/" + state.url;
            var redirectUrl = "" + environment.NEW_SITE_URL + currentPath;
            window.location.href = redirectUrl;
            return false;
        }
        else {
            return true;
        }
    };
    MyTeamsAccessGuard.ngInjectableDef = i0.defineInjectable({ factory: function MyTeamsAccessGuard_Factory() { return new MyTeamsAccessGuard(); }, token: MyTeamsAccessGuard, providedIn: "root" });
    return MyTeamsAccessGuard;
}());
export { MyTeamsAccessGuard };
